import {
  blank,
  box,
  fromMarkdown,
  lines,
  pad,
  vstack,
} from "../src";
import { C, MD_STYLE, setTermLayout, type DemoTermElement } from "./shared";

const EXAMPLE_CODE = `\`\`\`ts
import { registerTermUIElement } from "1ch";
import "1ch/style.css";

registerTermUIElement();
\`\`\`

\`\`\`html
<term-ui width="48" mode="dark">
  <section gap="1">
    <article title="deploy v2.4.1">
      <progress label="build" value="100" max="100"></progress>
      <progress label="tests" value="94" max="100"></progress>
      <progress label="cover" value="82" max="100"></progress>
    </article>
    <figure height="4" fill>4,7,5,12,9,14,8,11</figure>
    <footer left=" healthy" right="64s ago "></footer>
  </section>
</term-ui>
\`\`\``;

const OUTPUT_HTML = `
<section gap="1">
  <article title="deploy v2.4.1">
    <progress label="build" value="100" max="100"></progress>
    <progress label="tests" value="94" max="100"></progress>
    <progress label="cover" value="82" max="100"></progress>
  </article>
  <figure height="4" fill color="cyan" axis-color="brightBlack">4,7,5,12,9,14,8,11</figure>
  <footer left=" healthy" right="64s ago " bg="#1a1a2e" color="white"></footer>
</section>
`;

export function mountCodeReveal(codeTerm: DemoTermElement, outputTerm: DemoTermElement): void {
  setTermLayout(
    codeTerm,
    vstack(
      lines([[{ text: pad(" code", 56), color: C.brightBlack, bold: true }]]),
      lines([[{ text: "\u2500".repeat(56), color: C.border, noSelect: true }]]),
      blank(),
      fromMarkdown(EXAMPLE_CODE, { theme: C, overrides: MD_STYLE }),
      blank(),
    ),
  );

  outputTerm.layout = undefined;
  outputTerm.setAttribute("source", OUTPUT_HTML);
  outputTerm.render();
}
